'use client';

import { useMemo } from 'react';
import { NextIntlClientProvider } from 'next-intl';

function onIntlError(error) {
  if (
    error?.code === 'MISSING_MESSAGE' ||
    error?.code === 'ENVIRONMENT_FALLBACK' ||
    error?.code === 'FORMATTING_ERROR'
  ) {
    return;
  }
  console.error(error);
}

function messageFallback({ namespace, key }) {
  return namespace ? `${namespace}.${key}` : String(key || '');
}

function readDeviceTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Bogota';
  } catch {
    return 'America/Bogota';
  }
}

/**
 * next-intl date formatting must follow the device zone, not a hardcoded UTC
 * (that made agenda/sleep times look "shifted" for global users).
 */
export default function IntlClientProvider({ locale, messages, children }) {
  const timeZone = useMemo(() => readDeviceTimeZone(), []);

  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone={timeZone}
      onError={onIntlError}
      getMessageFallback={messageFallback}
    >
      {children}
    </NextIntlClientProvider>
  );
}
